<!--
	SPDX-FileCopyrightText: Ferdinand Thiessen <opensource@fthiessen.de>
	SPDX-License-Identifier: AGPL-3.0-or-later
-->
<template>
	<div :class="$style.wrapper">
		<h2 :class="$style.heading">
			{{ categoryName }}
		</h2>
		<CheckList
			:class="$style.list"
			:setup-checks="entries"
			@show-details="onOpenEntry" />
	</div>
</template>

<script setup lang="ts">
import type { ISetupCheck } from '../../types'
import CheckList from '../CheckList.vue'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
	categoryName: string
	entries: ISetupCheck[]
}>()

const emit = defineEmits<{
	(e: 'select-entry', v: ISetupCheck): void
}>()

const onOpenEntry = (entry: ISetupCheck) => emit('select-entry', entry)
</script>

<style module>
.wrapper {
	display: flex;
	flex: 1 0;
	flex-direction: column;

	& > * {
		box-sizing: border-box;
		padding-inline-end: 22px; /* add missing padding (see DetailsModal) */
	}
}

.heading {
	padding-inline-start: 10px; /* align with list item */
}

/* The list content */
.list {
	overflow: hidden scroll;
}
</style>
